<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="p-2">
    <form
      @submit.prevent="onSubmitSearch"
      @reset="onResetSearch"
    >
      <div class="row">
        <div class="col-sm-6">
          <span class="search-title">{{ $t('ins_report.from_date') }}</span>
            <input
                id="from_date"
                v-model="fromDate"
                type="date"
                class="form-control form-control-sm no-margin"
            />
        </div>

        <div class="col-sm-6">
          <span class="search-title">{{ $t('ins_report.to_date') }}</span>
            <input
                id="to_date"
                v-model="toDate"
                type="date"
                class="form-control form-control-sm"
            />
        </div>
      </div>
      <div class="col-sm-12 button-container">
          <button
              class="btn btn-danger form-button"
              type="reset"
          >
              {{ $t('ins_report.clear') }}
          </button>
        <button
          class="btn btn-primary form-button"
          type="submit"
        >
          {{ $t('ins_report.search') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import {inspectionHelper} from '../../mixins/InspectionMixin'
import {timeUtils} from '../../mixins/TimeUtils'

export default {
    name: 'VehicleInspectionSearch',
    mixins: [inspectionHelper, timeUtils],
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            fromDate: '',
            toDate: ''
        }
    },
    mounted() {
        this.fromDate = this.timestampToDateInput(new Date(this.getMonthStart()).getTime())
    },
    methods: {
        onResetSearch: function () {
            this.fromDate = ''
            this.toDate = ''
        },
        onSubmitSearch: function () {
            var params = {}
            if (this.fromDate !== null && this.fromDate.trim()) {
                params.from = this.localTimeToUtcTime(this.fromDate).toISOString()
            }
            if (this.toDate !== null && this.toDate.trim()) {
                params.to = this.getEndOfTheDay(this.toDate).toISOString()
            }
            this.$emit('search', params)
        },
    }
}
</script>
